import type { FormEvent } from 'react'
import React, { useEffect, useState } from 'react'

import { Box, Grid } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { ClearButton, SearchButton, SelectCenter, SelectItem } from 'components/commonparts'

import type { GetShipExpectedShipExpectedGetRequest } from 'api-client'

interface SearchConditionProps {
  searchParam: GetShipExpectedShipExpectedGetRequest
  onSearch: (requestParam: GetShipExpectedShipExpectedGetRequest) => void
  searchTrigger?: boolean 
}

function SearchCondition({ searchParam, onSearch, searchTrigger = false }: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()
  const [customerCompanyId, setCustomerCompanyId] = useState<number | undefined>(
    searchParam.companyId === loginUserInfo!.companyId ? undefined : searchParam.companyId
  )
  const [centerIsValid, setCenterIsValid] = useState(true)
  const [itemIsValid, setItemIsValid] = useState(true)
  const [centerId, setCenterId] = useState<number | null | undefined>(searchParam.centerId)
  const [itemCode, setItemCode] = useState<string | null | undefined>(searchParam.itemCode)

  const onClear = () => {
    setCustomerCompanyId(undefined)
    setItemCode('')
    setCenterId(undefined)
  }

  // Search using formEvent
  const handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // Block call data if center and item is inValid
    if (!centerIsValid && !itemIsValid) {
      onSearch({
        companyId: customerCompanyId ?? loginUserInfo!.companyId,
        centerId,
        itemCode,
      })
    }
  }

  useEffect(() => {
    if(!centerIsValid && !itemIsValid){
      onSearch({
        companyId: customerCompanyId ?? loginUserInfo!.companyId,
        centerId,
        itemCode,
      })   
    }
  }, [searchTrigger])

  return (
    // Wrap into a box to call formEvent
    <Box component="form" onSubmit={handleFormSubmit}>
      <Grid component="div" container>
        <Grid component="div" size={{ xs:12 }}>
          <SelectCenter
            trCompanyId={customerCompanyId ?? loginUserInfo!.companyId}
            centerId={centerId}
            setCenterId={setCenterId}
            setCenterInfo={() => {}}
            isRequired
            setIsValid={setCenterIsValid}
          />
          <SelectItem
            trCompanyId={customerCompanyId ?? loginUserInfo!.companyId}
            itemCode={itemCode ?? undefined}
            setItemCode={setItemCode}
            setItemInfo={() => {}}
            isRequred
            setIsValid={setItemIsValid}
          />
        </Grid>
        <Grid component="div" size={{ xs:12 }}>
          <Box display="flex" justifyContent="flex-end" alignItems="flex-end" marginTop="10px" marginRight="10px">
            <SearchButton searchId="item"/>
            <ClearButton onClick={onClear} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SearchCondition
